import React, { useMemo, useState } from "react";
import { FaAngleDown } from "react-icons/fa";
import { FiFilter } from "react-icons/fi";
import { useAppSelector } from "../../../utils/redux/hooks";
import { RootState } from "../../../utils/redux/store";
import { useNavigate } from "react-router-dom";
import GoBack from "../../GoBack";

export function formatDate(dateString: string) {
  const date = new Date(dateString);

  const gmtPlus1Date = new Date(date.getTime() + 60 * 60 * 1000);

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    timeZone: "Europe/London",
  } as Intl.DateTimeFormatOptions;

  // return date.toLocaleString("en-US", options);
  return gmtPlus1Date.toLocaleString("en-US", options);
}

const TempFour = () => {
  const _viewOrder: any = useAppSelector(
    (store: RootState) => store.user.viewOrder
  );
  let viewOrder = _viewOrder?.order;
  let review: { averageRating?: number }[] = _viewOrder?.review;

  const avgTotalRating = useMemo(() => {
    const ratings = review.map((item) => item?.averageRating ?? 0);
    const total = ratings.reduce((acc, rating) => acc + rating, 0);
    const average = ratings.length > 0 ? total / ratings.length : 0;
    return average;
  }, [review]);

  const viewWallet: any = useAppSelector(
    (store: RootState) => store.user.viewWallet
  );

  const viewCustomer: any = useAppSelector(
    (store: RootState) => store.user.viewCustomer
  );

  console.log("-----------view customer ", viewOrder);

  return (
    <div className="lg:px-3 px-0 space-y-4">
      <div className="flex justify-between mb-4">
        <div className="flex flex-col lg:flex-row justify-between gap-4 items-center">
          <div className="flex gap-4 text-[#88087B] items-center">
            <GoBack />
            <p className="font-roboto text-2xl lg:text-3xl font-medium leading-normal">
              {/* {viewCustomer?.firstName}{" "}{viewCustomer?.lastName} */}
              {viewOrder?.serviceProvider?.firstName}{" "}
              {viewOrder?.serviceProvider?.lastName}
            </p>
            {/* <p className="border-l-2 border-[#000] px-2 font-roboto text-base sm:text-lg font-medium leading-normal">
              Rating: {viewCustomer?.rating | 0}
            </p> */}
            {/* <p className="border border-[#000] px-1 font-roboto text-base sm:text-lg font-medium leading-normal">
              Wallet Balance: ₦ {viewCustomer?.wallet?.availableBalance}
            </p> */}
          </div>
          {/* <FiFilter size={20} className="text-[#88087B] hidden lg:block" /> */}
        </div>
        {/* <div className="flex lg:hidden flex-col text-[#88087B]  justify-between gap-4 items-center">
          <div className="flex gap-8  items-center">
            <p className="font-roboto text-3xl lg:text-3xl font-medium leading-normal">
              {viewCustomer?.firstName} {viewCustomer?.lastName}
            </p>
            <p className="border-l-2 border-[#000] px-6 font-roboto text-base sm:text-lg font-medium leading-normal">
              Rating: 4.8
            </p>
          </div>

          <p className="border border-[#000] px-2 font-roboto text-base sm:text-xl font-medium leading-normal">
            Wallet Balance: ₦{" "}
            {viewWallet?.wallet?.availableBalance.toLocaleString()}
          </p>
        </div> */}
        {/* <div className="flex gap-10 text-[#88087B] items-center">
          <p className="font-roboto text-3xl font-medium leading-normal">
            First Last
          </p>
          <p className="border-l-2 border-[#000] px-2 font-roboto text-lg font-medium leading-normal">
            Rating: 4.8
          </p>
          <p className="border border-[#000]  px-2 font-roboto text-lg font-medium leading-normal">
            Wallet Balance: ₦ 10,000
          </p>
        </div> */}
        {/* <FiFilter size={20} className="text-[#88087B]" /> */}
      </div>

      <p className="text-[#000] font-roboto text-2xl font-medium leading-normal  border-b-2 border-[#000] w-fit px-4">
        Order Information
      </p>
      <main className="flex flex-col lg:flex-row gap-2 lg:gap-6 w-full lg:w-11/12">
        <section className="flex flex-col w-full lg:w-1/2 mt-6 mb-6 lg:mb-14 px-0 lg:px-4 gap-6">
          <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
            <p className="flex items-center font-roboto text-base font-normal leading-relaxed">
              Date:{" "}
              <input
                value={formatDate(viewOrder?.createdAt)}
                className="ml-4 flex-grow bg-[#fff] rounded-lg px-1"
              ></input>
            </p>
          </div>
          <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
            <p className="flex items-center font-roboto text-base font-normal leading-relaxed">
              Amount:{" "}
              <input
                value={`₦ ${viewOrder?.totalPrice.toLocaleString()}`}
                className="ml-4 flex-grow bg-[#fff] rounded-lg px-1"
              ></input>
              {/* <span className="ml-4 flex-grow bg-[#fff] rounded-lg px-1">
                ₦ {viewOrder?.totalPrice}
              </span>  */}
            </p>
          </div>
          <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
            <p className="flex items-center font-roboto text-base font-normal leading-relaxed">
              Order ID:{" "}
              <input
                value={viewOrder?._id}
                className="ml-4 flex-grow bg-[#fff] rounded-lg px-1"
              ></input>
              {/* <            <span className="ml-4 flex-grow bg-[#fff] rounded-lg px-1">
               {viewOrder?._id}
              </span>  */}
            </p>
          </div>
          <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
            <p className="flex items-center font-roboto text-base font-normal leading-relaxed whitespace-nowrap overflow-hidden">
              Service Providers:{" "}
              <input
                value={`${viewOrder?.serviceProvider?.firstName} ${viewOrder?.serviceProvider?.lastName}`}
                className="lg:ml-4 ml-0 flex-grow bg-[#fff] rounded-lg px-1"
              ></input>
              {/* <span className="ml-4 flex-grow bg-[#fff] rounded-lg px-1">
              {viewOrder?.serviceProvider?.firstName}   {viewOrder?.serviceProvider?.lastName}
              </span>  */}
            </p>
          </div>
          <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
            <p className="flex items-center font-roboto text-base font-normal leading-relaxed">
              Address:{" "}
              <span className="ml-4 flex flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between">
                {viewOrder?.address || " null"}
                {/* <FaAngleDown size={20} className="cursor-pointer" /> */}
              </span>
            </p>
          </div>
          <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
            <p className="flex items-center font-roboto text-base font-normal leading-relaxed">
              Location:{" "}
              <input
                value={viewOrder?.location}
                className="ml-4 flex-grow bg-[#fff] rounded-lg px-1"
              ></input>
              {/* <span className="ml-4 flex-grow bg-[#fff] rounded-lg px-1">
              {viewOrder?.location}
              </span>  */}
            </p>
          </div>
          <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
            <p className="flex items-center font-roboto text-base font-normal leading-relaxed">
              Status:{" "}
              <input
                value={viewOrder?.status}
                className="ml-4 flex-grow bg-[#fff] rounded-lg px-1"
              ></input>
              {/* <span className="ml-4 flex-grow bg-[#fff] rounded-lg px-1">
              {viewOrder?.status}
              </span>  */}
            </p>
          </div>
          <div className="flex-shrink-0 bg-[#8E8E93] border border-[#88087B] rounded-sm flex flex-row ">
            <p className="flex items-start font-roboto text-base font-normal leading-5 pr-3 ">
              Job Description:
            </p>

            <textarea
              className="bg-[#fff] rounded-lg px-1 flex-grow text-black font-inter text-xs font-normal leading-4 resize-none overflow-hidden overflow-y-auto"
              rows={5}
              value={viewOrder?.description}
            />

            {/* <span className="bg-[#fff] rounded-lg px-1 flex-grow overflow-hidden h-20 text-black font-inter text-xs font-normal leading-4">
              <span className="font-medium">Plumbing</span> <br />  {viewOrder?.description}
            </span> */}
          </div>
          <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
            <p className="flex items-center font-roboto text-base font-normal leading-relaxed">
              Tip:{" "}
              <span className="ml-4 flex-grow bg-[#fff] rounded-lg px-1">
                ₦ 0
              </span>
            </p>
          </div>
        </section>
        <span className="border-r-2 border-[#000] hidden lg:block"></span>
        <section className="flex flex-col w-full lg:w-1/2 mt-6 mb-10 px-0 lg:px-4 gap-6">
          <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
            <p className="flex items-center font-roboto text-base font-normal leading-relaxed">
              Rating:{" "}
              <input
                value={avgTotalRating}
                className="ml-4 flex-grow bg-[#fff] rounded-lg px-1"
              ></input>
              {/* <            <span className="ml-4 flex-grow bg-[#fff] rounded-lg px-1">
               {viewOrder?._id}
              </span>  */}
            </p>
          </div>
          {`${viewOrder?.status}`.toLowerCase() === "cancelled" && (
            <div className="flex-shrink-0 bg-[#8E8E93] border border-[#88087B] rounded-sm flex flex-row ">
              <p className="flex items-start font-roboto text-base font-normal leading-5 pr-3">
                Reason for Canceling Orders:
              </p>
              <textarea
                className="bg-[#fff] rounded-lg px-1 flex-grow overflow-hidden h-20 text-black font-inter text-xs font-normal leading-4 whitespace-nowrap resize-none"
                rows={5}
                value={viewOrder?.cancelReason}
              />
            </div>
          )}
          {/*   <div className="flex-shrink-0 bg-[#8E8E93] border border-[#88087B] rounded-sm flex flex-row ">
            <p className="flex items-start font-roboto text-base font-normal leading-5 pr-3">
              Service Provider Review:
            </p>
            <textarea
              className="bg-[#fff] rounded-lg px-1 flex-grow overflow-hidden  text-black font-inter text-xs font-normal leading-4 whitespace-nowrap resize-none "
              rows={5}
            />
          </div>
          <div className="flex-shrink-0 bg-[#8E8E93] border border-[#88087B] rounded-sm flex flex-row ">
            <p className="flex items-start font-roboto text-base font-normal leading-5 pr-3">
              Order Dispute 1:
            </p>
            <textarea
              className="bg-[#fff] rounded-lg px-1 flex-grow overflow-hidden h-24 text-black font-inter text-xs font-normal leading-4 whitespace-nowrap resize-none "
              rows={5}
            />
          </div>
          <div className="flex-shrink-0 bg-[#8E8E93] border border-[#88087B] rounded-sm flex flex-row ">
            <p className="flex items-start font-roboto text-base font-normal leading-5 pr-3">
              Rate your experience:
            </p>
            <textarea
              className="bg-[#fff] rounded-lg px-1 flex-grow overflow-hidden h-32 text-black font-inter text-xs font-normal leading-4 whitespace-nowrap resize-none "
              rows={5}
            />
          </div>
          <div className="flex-shrink-0 bg-[#8E8E93] border border-[#88087B] rounded-sm flex flex-row ">
            <p className="flex items-start font-roboto text-base font-normal leading-5 pr-3">
              Private Feedback:
            </p>
            <textarea
              className="bg-[#fff] rounded-lg px-1 flex-grow overflow-hidden  text-black font-inter text-xs font-normal leading-4 whitespace-nowrap resize-none "
              rows={5}
            />
          </div>
          <div className="flex-shrink-0 bg-[#8E8E93] border border-[#88087B] rounded-sm flex flex-row ">
            <p className="flex items-start font-roboto text-base font-normal leading-5 pr-3">
              Order Dispute 2:
            </p>
            <textarea
              className="bg-[#fff] rounded-lg px-1 flex-grow overflow-hidden h-24 text-black font-inter text-xs font-normal leading-4 whitespace-nowrap resize-none "
              rows={5}
            />
          </div>*/}
        </section>
      </main>
    </div>
  );
};

export default TempFour;
